/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entityassetsdescription2Inputs */

const id_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefak dan media`)
};

const ms_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefak dan media`)
};

const da_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakter og medier`)
};

const de_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakte und Medien`)
};

const en_us2_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution records`)
};

const es_es2_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de distribución`)
};

const es_mx2_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefactos y multimedia`)
};

const fil_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga artifact at media`)
};

const fr_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefacts et ressources multimédia`)
};

const it_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefatti e media`)
};

const hu_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefaktumok és média`)
};

const nl_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefacten en media`)
};

const no_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakter og media`)
};

const pl_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakty i multimedia`)
};

const pt_br2_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefatos e assets multimídia`)
};

const pt_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefactos e multimédia`)
};

const ro_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefacte și media`)
};

const fi_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artfaktit ja media`)
};

const sv_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakter och media`)
};

const vi_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefact và phương tiện`)
};

const tr_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapıtlar ve medya`)
};

const cs_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artefakty a média`)
};

const bg_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Артефакти и медия`)
};

const ru_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи об ассетах`)
};

const uk_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Артефакти та медіа`)
};

const ar_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحف والوسائط`)
};

const hi_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कलाकृतियाँ और मीडिया`)
};

const th_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อาร์ทิแฟกต์และสื่อ`)
};

const ja_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーティファクトとメディア`)
};

const zh_cn2_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制品与媒体`)
};

const zh_hant1_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製品與媒體`)
};

const ko_sandboxes_entityassetsdescription2 = /** @type {(inputs: Sandboxes_Entityassetsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아티팩트 및 미디어`)
};

/**
* | output |
* | --- |
* | "Distribution records" |
*
* @param {Sandboxes_Entityassetsdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entityassetsdescription2 = /** @type {((inputs?: Sandboxes_Entityassetsdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entityassetsdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entityassetsdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entityassetsdescription2(inputs)
	if (locale === "da") return da_sandboxes_entityassetsdescription2(inputs)
	if (locale === "de") return de_sandboxes_entityassetsdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entityassetsdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entityassetsdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entityassetsdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entityassetsdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entityassetsdescription2(inputs)
	if (locale === "it") return it_sandboxes_entityassetsdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entityassetsdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entityassetsdescription2(inputs)
	if (locale === "no") return no_sandboxes_entityassetsdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entityassetsdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entityassetsdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entityassetsdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entityassetsdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entityassetsdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entityassetsdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entityassetsdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entityassetsdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entityassetsdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entityassetsdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entityassetsdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entityassetsdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entityassetsdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entityassetsdescription2(inputs)
	if (locale === "th") return th_sandboxes_entityassetsdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entityassetsdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entityassetsdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entityassetsdescription2(inputs)
	return ko_sandboxes_entityassetsdescription2(inputs)
});
export { sandboxes_entityassetsdescription2 as "sandboxes.entityAssetsDescription" }